import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { HardHatIcon, XIcon } from 'lucide-react';
import { PRODUCT_NAME, PURCHASE_ANCHOR, popupSales } from '../data/content';
export function SalesPopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const reduceMotion = useReducedMotion();
  useEffect(() => {
    if (dismissed) return;
    let timeout: ReturnType<typeof setTimeout>;
    const cycle = (i: number) => {
      timeout = setTimeout(() => {
        setIndex(i % popupSales.length);
        setVisible(true);
        timeout = setTimeout(() => {
          setVisible(false);
          cycle(i + 1);
        }, 5200);
      }, 3200);
    };
    cycle(0);
    return () => clearTimeout(timeout);
  }, [dismissed]);
  const sale = popupSales[index];
  const y = reduceMotion ? 0 : 14;
  return <AnimatePresence data-id="element-136" data-mp="18rncdvu0cv8j">
      {visible && !dismissed ? <motion.aside initial={{
      opacity: 0,
      y,
      scale: reduceMotion ? 1 : 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y,
      scale: reduceMotion ? 1 : 0.96
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-2 left-2 z-50 w-[14.5rem] overflow-hidden rounded-lg border-2 border-warning bg-carbon shadow-xl shadow-safety/30 ring-2 ring-safety sm:w-[17rem]" aria-live="polite" data-id="element-137" data-mp="1zse42bllhamu">
          <div className="flex items-center gap-1.5 bg-safety px-2 py-1" data-id="element-138" data-mp="2nge6i8s9qph9">
            <HardHatIcon className="h-3.5 w-3.5 text-carbon" strokeWidth={2.5} aria-hidden="true" data-id="element-139" data-mp="2sga7dz5o60sl" />
            <p className="text-[0.56rem] font-black uppercase tracking-[0.14em] text-carbon" data-id="element-140" data-mp="2xf3cp4asylho">
              New purchase verified
            </p>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="ml-auto text-carbon/70 transition-colors duration-150 ease-out hover:text-carbon" data-id="element-141" data-mp="y3kd3gbe2pko">
              <XIcon className="h-3 w-3" aria-hidden="true" data-id="element-142" data-mp="q22za1h1aa15" />
            </button>
          </div>
          <a href={PURCHASE_ANCHOR} className="block border-l-4 border-warning px-2 py-1.5" data-id="element-143" data-mp="14zd9l7hxx9va">
            <p className="text-[0.72rem] font-bold leading-tight text-white" data-id="element-144" data-mp="1000qmxu6wmxz">
              {sale.name} just bought <span className="text-safety" data-id="element-145" data-mp="1dz0bduel0hov">{PRODUCT_NAME}</span>
            </p>
            <p className="mt-0.5 text-[0.62rem] font-semibold text-mist" data-id="element-146" data-mp="190fbxx75m21h">
              {sale.city}, {sale.country} • a few minutes ago
            </p>
          </a>
        </motion.aside> : null}
    </AnimatePresence>;
}